import { LooseAutocomplete, TODO } from '@b2b/types/core';
import invariant from 'tiny-invariant';

export interface DetailListOptions {
  /**
   * Path to $scope property
   */
  data: string;
  columns: number;
  exclude: TODO[];
  include: TODO[];
  filters: Record<string, TODO>;
  templates: Record<string, TODO>;
  mappings: Record<string, TODO>;
  clickHandler: Record<string, TODO>;
  layout: LooseAutocomplete<'N'>;
  sorting: TODO;
  showEmpty: boolean;
  columnWidth: number;
  hideLabels: boolean;
  hideTitles: TODO[];
}

export function createDetailListOptions(options: Partial<DetailListOptions>): DetailListOptions {
  invariant(options.data);
  const columns = options.columns || 0;

  return {
    data: options.data,
    columns,
    exclude: options.exclude || [],
    include: options.include || [],
    filters: options.filters || {},
    templates: options.templates || {},
    mappings: options.mappings || {},
    clickHandler: options.clickHandler || {},
    layout: options.layout || 'N',
    sorting: options.sorting,
    showEmpty: options.showEmpty || false,
    columnWidth: options.columnWidth ? options.columnWidth : Math.floor(12 / columns),
    hideLabels: options.hideLabels || false,
    hideTitles: options.hideTitles || [],
  };
}
